import { shallowEqual, useSelector } from "react-redux"
import { RootState } from "../setup"
import { UserModel } from "../app/modules/auth/models/UserModel"

function useUser() {
    return useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
}

export default useUser